import { ChangeDetectionStrategy, Component } from '@angular/core';


import { ContentWidgetTag, Setting } from '@app/common';
import { AccountData, SessionService, TermApproval } from '@app/core';
import { TermsService } from '@app/terms/services';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TermsDisplayComponent } from '../../../components/terms-display/terms-display.component';


@Component({
    templateUrl: './usd-pad-terms.component.html',
    styleUrls: ['./usd-pad-terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatCard,
        MatCardContent,
        TermsDisplayComponent,
    ],
})
export class UsdPadTermsComponent {

  public ContentWidgetTag = ContentWidgetTag;
  public Setting = Setting;

  constructor(
    private _accountData: AccountData,
    private _sessionService: SessionService,
    private _termsService: TermsService,
  ) { }

  public submit() {
    this._accountData.put({
      id: this._sessionService.account().id,
      usdPadTermsAccepted: new Date(),
    })
      .subscribe(() => {
        this._termsService.processTerms(TermApproval.isUsdPadRequired);
      });
  }

}
